var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sports-page" },
    [
      _c(
        "v-layout",
        { staticClass: "page-layout" },
        [
          _c(
            "v-flex",
            {
              ref: "maincolumn",
              staticClass: "main-column",
              style: { paddingTop: _vm.headerHeight + "px" }
            },
            [
              _c("resize-observer", { on: { notify: _vm.mainColumnResize } }),
              _vm._v(" "),
              _c("div", { staticClass: "staticcontent" }, [
                _vm.tabletAndAbove
                  ? _c(
                      "div",
                      { staticClass: "static_content_links" },
                      [
                        _c("div", { staticClass: "sc_header" }, [
                          _vm._v(_vm._s(_vm.$t("StaticContent.AboutUs")))
                        ]),
                        _vm._v(" "),
                        _c("site-navigation", {
                          staticClass: "sc_links",
                          attrs: { "navigation-section": "ABOUT_US" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "static-content accpage" },
                  [_c("ps-promotion")],
                  1
                ),
                _vm._v(" "),
                _vm.tabletAndAbove && _vm.isReadOnly
                  ? _c(
                      "div",
                      { staticClass: "banners" },
                      [
                        _c("headlinesLight", {
                          attrs: { category: "SidebarBanners" }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2240ca8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2240ca8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/StaticPromotionPage.vue
// module id = null
// module chunks = 